<template>
    <div>
        <div>
            <v-tooltip
                :disabled="$store.getters.saveState === 'readOnly'"
                top
            >
                <template v-slot:activator="{ on }">
                    <span
                        :block="true"
                        :disabled="$store.getters.saveState === 'readOnly'"
                        :loading="saveState === 'sync'"
                        class="save-datamodel-btn"
                        @click="saveModelisation"
                        :class="saveBtnClass"
                    >
                        {{ saveBtnText }}
                        <i v-if="saveState === 'unsaved'" class="el-icon-warning"></i>
                        <i v-else-if="saveState === 'error'" class="el-icon-error"></i>
                        <i v-else-if="saveState === 'upToDate'" class="el-icon-success"></i>
                    </span>
                </template>
                <span></span>
            </v-tooltip>
        </div>
        <br>
        <div class="ns-timeline">
            <div
                v-for="(item, index) in items"
                :key="index"
                class="timeline-step"
            >
                <div
                    class="timeline-bullet"
                    :class="{'blue': selectedItem && selectedItem.uid === item.uid}"
                    @click="selectItem(item)"
                ></div>
                <div class="timeline-text">
                    <strong>{{ item.title }}</strong>
                    <small v-if="item.readOnly" class="grey--text darken-3">
                        {{$t('partials.timeline.descr')}}
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon small dark v-on="on" color="#9e9e9e">info</v-icon>
                            </template>
                            <span>{{$t('partials.timeline.tooltip_text')}}</span>
                        </v-tooltip>
                    </small>
                    <p> {{ item.text }} </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: {
        items: {
            Type: Array,
            required: true,
        },
        selectedItem: {
            type: Object,
            required: false,
        },
    },
    data (){
        return {
        };
    },
    computed: {
        ...mapGetters([
            'saveState'
        ]),
        saveBtnColor (){
            if(this.saveState === 'upToDate'){
                return 'success';
            }else if(this.saveState === 'error'){
                return 'error';
            }else if(this.saveState === 'sync' || this.saveState === 'unsaved'){
                return 'info';
            }
        },
        saveBtnTooltipText (){
            if(this.saveState === 'upToDate'){
                return this.$t('partials.timeline.save_btn.tooltip_text.up_to_date');
            }else if(this.saveState === 'error'){
                return this.$t('partials.timeline.save_btn.tooltip_text.error');
            }else if(this.saveState === 'sync'){
                return this.$t('partials.timeline.save_btn.tooltip_text.sync');
            }else if(this.saveState === 'unsaved'){
                return this.$t('partials.timeline.save_btn.tooltip_text.unsaved');
            }
        },
        saveBtnText (){
            if(this.saveState === 'upToDate'){
                return this.$t('partials.timeline.save_btn.text.up_to_date');
            }else{
                return this.$t('partials.timeline.save_btn.text.save');
            }
        },
        saveBtnClass(){
            if(this.saveState === 'upToDate'){
                return 'status-saved';
            }else if(this.saveState === 'error'){
                return 'status-error';
            }else if( this.savaState === 'sync'){
                return 'status-sync';
            }else if(this.saveState ==='unsaved'){
                return 'unsaved';
            }
        },
    },
    created (){
    },

    methods: {
        selectItem (item){
            this.$emit('selected-item', item);
        },
        saveModelisation (){
            if(this.saveState === 'unsaved'){
                this.$eventBus.$emit('save-schema');
            }
        },
    },
};
</script>

<style lang="scss">
.save-datamodel-btn{
    background-color: #303030;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: uppercase;
    width: 100%;
    padding: 8px;
    border-radius: 3px;
    i{
        margin-left: 5px;
    }

}

.status-saved{
}
.status-error{

}
.status-sync{

}
.unsaved{
    background-color: #409EEF;
    border-radius: 5px;
    padding: 8px 12px;
    cursor: pointer;
}

.ns-timeline{
    margin-left: 15px;

    .is-read-only{
        font-size: 7px;
    }

    .timeline-step{
        display: flex;
        flex-wrap: wrap;
        height: 94px;
        .timeline-bullet{
            flex-basis: 14px;
            width: 14px;
            height: 14px;
            border-radius: 14px;
            border: 2px solid #fff;
            border-color: #fff !important;
            background-color: #303030;
            position: relative;
            margin-top: 4px;
            cursor: pointer;
            &:before{
                content: "";
                position: absolute;
                height: 80px;
                left: 5px;
                top: 12px;
                width: 1px;
                background-color: #fff;
            }
        }
        .selected-item{
            background-color: blue;
        }
        .timeline-text{
            flex-basis: calc(100% - (14px + 10px));
            margin-left: 10px;
            .v-icon {
                font-size: 14px;
                cursor: default;
            }
        }
    }
}
.ns-timeline .timeline-step:last-child .timeline-bullet::before{
    content: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/timeline.vue